import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import { ColorsStyle } from "../config/colors";

import SEO from "../components/SEO";
import LandingSobre from "../components/LandingSobre";
import LandingMarquee from "../components/LandingMarquee";
import LandingFuncionalidades from "../components/LandingFuncionalidades";
import LandingDepoimentos from "../components/LandingDepoimentos";
import LandingComunidade from "../components/LandingComunidade";
import LandingHeader from "../components/LandingHeader";
import LandingContato from "../components/LandingContato";
import LandingFooter from "../components/LandingFooter";
import LandingFAQ from "../components/LandingFAQ";

export default function Landing(){

	return (
		<div className="d-flex justify-content-center align-items-center flex-column" style={{backgroundColor: ColorsStyle.Grey800}}>
			<SEO/>
			
			<LandingHeader/>

			<Container fluid id="inicio" className="px-2 px-lg-5 d-flex flex-column justify-content-center align-items-center position-relative overflow-hidden" style={{minHeight: "100svh", paddingTop: 86}}>
				<motion.div initial={{opacity: 0}} animate={{opacity: 1, transition: {delay: 0, duration: 1, type: 'tween'}}} className="position-absolute" style={{inset: 0, zIndex: 0, background: 'url(background.webp)', backgroundColor: ColorsStyle.Opacity80, backgroundBlendMode: "color", backgroundSize: "cover"}}/>
				<div className="position-absolute" style={{inset: 0, zIndex: 1, background: `linear-gradient(transparent 85%, ${ColorsStyle.Grey800})`}}/>
				<Container className="d-flex align-items-stretch flex-fill" style={{zIndex: 2}}>
					<Row>
						<Col lg={8} xl={6} className="d-flex flex-column justify-content-center">
							<motion.h1 initial={{y: 50, opacity: 0}} animate={{y: 0, opacity: 1, transition: {delay: 0.100, duration: 0.2, type: 'tween'}}} className="mb-2 text-warning tribo-barber" style={{textShadow: "2px 2px 2px #000000AA"}}>
								TRIBO BARBER
							</motion.h1>
							<motion.div initial={{y: 50, opacity: 0}} animate={{y: 0, opacity: 1, transition: {delay: 0.150, duration: 0.2, type: 'tween'}}} className="mb-2 fs-2 fw-light" style={{textShadow: "2px 2px 2px #000000AA"}}>
								Somos uma <span className="fw-bold">plataforma de gestão</span> focada em inovar barbearias com <span className="fw-bold">eficiência e exclusividade</span>, ao mesmo tempo em que <span className="fw-bold">capacitamos</span> os <span className="fw-bold">profissionais</span> a prosperar.
							</motion.div>
							<motion.div initial={{y: 50, opacity: 0}} animate={{y: 0, opacity: 1, transition: {delay: 0.200, duration: 0.2, type: 'tween'}}} className="mt-3">
								<motion.a whileHover={{scale: 1.05}} whileTap={{scale: 0.95}} className="btn btn-warning me-3 mb-3" onClick={()=>{ window.dataLayer.push({ event: 'install_android' }); }} href="https://play.google.com/store/apps/details?id=com.tribobarber" target="_blank" rel="noreferrer" style={{alignItems: 'center', padding: 10, width: 250}}>
									<div className="d-flex flex-row">
										<img src="google-play.png" alt="google play" style={{height: 50}}/>
										<div style={{flex: 1, paddingLeft: 10}}>
											<div style={{textAlign: 'left', fontWeight: 'bold', lineHeight: 1, fontSize: 14}}>Disponível na</div>
											<div style={{textAlign: 'left', fontWeight: 'bold', lineHeight: 1, fontSize: 28}}>Google Play</div>
										</div>
									</div>
								</motion.a>
								<motion.a whileHover={{scale: 1.05}} whileTap={{scale: 0.95}} className="btn btn-warning me-3 mb-3" onClick={()=>{ window.dataLayer.push({ event: 'install_ios' }); }} href="https://apps.apple.com/br/app/tribo-barber/id1591303959" target="_blank" rel="noreferrer" style={{alignItems: 'center', padding: 10, width: 250}}>
									<div className="d-flex flex-row">
										<img src="app-store.png" alt="app store" style={{height: 50}}/>
										<div style={{flex: 1, paddingLeft: 10}}>
											<div style={{textAlign: 'left', fontWeight: 'bold', lineHeight: 1, fontSize: 14}}>Disponível na</div>
											<div style={{textAlign: 'left', fontWeight: 'bold', lineHeight: 1, fontSize: 28}}>App Store</div>
										</div>
									</div>
								</motion.a>
							</motion.div>
						</Col>
						<Col lg={4} xl={{span: 4, offset: 2}} className="d-none d-lg-flex position-relative">
							<motion.img initial={{x: 100, opacity: 0}} animate={{x: 0, opacity: 1, transition: {delay: 0.200, duration: 0.500, type: "tween", ease: "easeOut"}}} src="banner.webp" alt="Aplicativo Tribo Barber no Smartphone" className="position-absolute w-100 p-5" style={{height: "100%", inset: 0, objectFit: 'contain'}}/>
						</Col>
					</Row>
				</Container>
			</Container>

			<LandingSobre />
			
			<LandingMarquee />

			<LandingFuncionalidades />

			<LandingDepoimentos />

			<LandingComunidade />

			<LandingContato />

			<LandingFAQ />

			<LandingFooter />
		</div>
	)}